import { createSvgIcon } from '@mui/material';

export const VisaCardIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19243_22600)'>
      <rect
        x='8'
        y='4'
        width='37.2537'
        height='24'
        rx='4.29851'
        fill='#E7EBFA'
      />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <path
        d='M26.3991 12.089L24.6614 20.2116H22.5603L24.2982 12.089H26.3991ZM35.2394 17.3338L36.3457 14.2835L36.9822 17.3338H35.2394ZM37.5838 20.2116H39.5274L37.8314 12.089H36.0374C35.6343 12.089 35.2942 12.3235 35.1428 12.6849L31.9904 20.2116H34.197L34.635 18.9987H37.3308L37.5838 20.2116ZM32.0999 17.5596C32.1089 15.4157 29.1352 15.2977 29.1558 14.3401C29.1619 14.0483 29.4399 13.7387 30.0468 13.6593C30.3484 13.62 31.1775 13.5899 32.1189 14.0231L32.4876 12.3006C31.9819 12.117 31.3312 11.9404 30.5219 11.9404C28.4452 11.9404 26.9834 13.0446 26.9711 14.6257C26.958 15.7949 28.0146 16.4474 28.8108 16.8361C29.6293 17.2343 29.9044 17.4894 29.9008 17.8454C29.8954 18.3907 29.2478 18.6308 28.6437 18.6403C27.587 18.657 26.9739 18.3552 26.4852 18.1275L26.1044 19.9073C26.5952 20.1327 27.5014 20.3286 28.4416 20.3386C30.6487 20.3386 32.0927 19.2481 32.0999 17.5596ZM23.3966 12.089L19.9922 20.2116H17.7708L16.0956 13.7292C15.9938 13.33 15.9053 13.184 15.5961 13.0156C15.0914 12.7418 14.2572 12.4844 13.5232 12.325L13.5733 12.089H17.1486C17.6042 12.089 18.0142 12.3924 18.1176 12.9171L19.0025 17.6177L21.189 12.089H23.3966Z'
        fill='#1434CB'
      />
    </g>
    <defs>
      <filter
        id='filter0_dd_19243_22600'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19243_22600'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19243_22600'
          result='effect2_dropShadow_19243_22600'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19243_22600'
          result='shape'
        />
      </filter>
    </defs>
  </svg>,
  'VisaCardIcon',
);
